import "./footerColOne.css";
function FooterColOne() {
  return (
    <div className="col1">
      <div className="title">CINEMA</div>
      <div className="lorem">
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Porro maiores
        numquam libero totam facilis quasi voluptates, earum voluptatibus harum
        repellat distinctio ipsa, sit beatae velit dolores provident saepe
        facere molestiae.
      </div>
      <div className="iconsSocialMedia">
        <ion-icon name="logo-instagram"></ion-icon>
        <ion-icon name="logo-twitter"></ion-icon>
        <ion-icon name="logo-facebook"></ion-icon>
        <ion-icon name="logo-youtube"></ion-icon>
      </div>
    </div>
  );
}

export default FooterColOne;
